module.exports = __webpack_public_path__ + "db90e9a1a12b7d60e97c7fa4618fa2ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/CreateEventHovercard/create-event-introduction.svg
// module id = 3155
// module chunks = 0 1